import React, { useRef } from 'react';
import { Workspace, WORKSPACE_LABELS } from '../../lib/workspace';

interface WorkspaceToggleProps {
  value: Workspace;
  onChange: (workspace: Workspace) => void;
}

const OPTIONS: Workspace[] = ['client', 'expert'];

export default function WorkspaceToggle({ value, onChange }: WorkspaceToggleProps) {
  const refs = useRef<Array<HTMLButtonElement | null>>([]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>, index: number) => {
    let next = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (index + 1) % OPTIONS.length;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (index - 1 + OPTIONS.length) % OPTIONS.length;
    if (e.key === 'Home') next = 0;
    if (e.key === 'End') next = OPTIONS.length - 1;
    if (next < 0) return;
    e.preventDefault();
    refs.current[next]?.focus();
    onChange(OPTIONS[next]);
  };

  return (
    <div
      role="radiogroup"
      aria-label="Workspace"
      className="grid grid-cols-2 gap-0.5 border border-gray-200 bg-gray-100 p-0.5"
    >
      {OPTIONS.map((option, index) => {
        const checked = option === value;
        return (
          <button
            key={option}
            ref={(el) => (refs.current[index] = el)}
            type="button"
            role="radio"
            aria-checked={checked}
            tabIndex={checked ? 0 : -1}
            onClick={() => onChange(option)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className={`px-2 py-2 text-xs font-medium leading-tight text-center focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
              checked ? 'bg-white text-indigo-700 shadow-sm' : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            {WORKSPACE_LABELS[option]}
          </button>
        );
      })}
    </div>
  );
}
